import Button from '@components/interactive/Button';
import TextLink from '@components/interactive/TextLink';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';

export const InvalidLink = ({ handleResendLink, status }) => {
  const statusDictionary = {
    INVALID: {
      header: "Looks like this isn't the latest link we sent you.",
      text: "Please make sure to click the latest link we sent you. If you can't find it, click below for a new link.",
    },
    USED: {
      header: 'This link has been used.',
      text: 'This link has already been used. Click below to request a new link.',
    },
    EXPIRED: {
      header: 'Almost there!',
      text:
        'To keep your account secure, we expire "sign-in" links after 60 minutes. Click below to receive a fresh link in your email.',
    },
    ERROR: {
      header: 'Something went wrong.',
      text: "We're having trouble signing you in right now.",
    },
  };

  const { header, text } = statusDictionary[status] || statusDictionary.INVALID;

  const ErrorComponent = () => (
    <Body1>
      If you continue having difficulties, email{' '}
      <TextLink href="mailto: accounts@fairsquaremedicare.com" text="accounts@fairsquaremedicare.com." />
    </Body1>
  );

  return (
    <>
      <Header as="h1">{header}</Header>
      <Body1>{text}</Body1>
      <Button onClick={handleResendLink}>Send me a new link</Button>
      {status === 'ERROR' && <ErrorComponent />}
    </>
  );
};
